module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"hankintaverkko","short_name":"hankintaverkko","start_url":"/","background_color":"white","theme_color":"#1a0d60","display":"minimal-ui","icon":"src/images/favicon-32x32.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"4d588fe8c41fbe94fc0cbb45c2d95750"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
